import { Utils } from '@/web-framework/api/utils';
import store from '@/public/store';
const WeiXinAPI = {
    /**
     * 获取微信扫码登录配置
     */
    getLoginWxappSetting() {
        return Request.get('/weixin/wxapp/getLoginWxappSetting');
    },
    saveApp(data) {
        return Request.post('/weixin/wxapp/save', data);
    },
    getPubnoBySiteId(siteId) {
        return Request.get(`/weixin/pubno/getPubnoBySiteId?siteId=${siteId}`);
    },
    /**
     * 获取项目设置的模板消息
     */
    findTemplateMessage(siteId) {
        return Request.get('/weixin/template_message/findTemplateList');
    },

    /**
     * 获取微信公众号配置的模板消息
     */
    findTemplateMessageOnWeiXin() {
        return Request.get('/weixin/template_message/findTemplateMessageOnWeiXin');
    },

    /**
     * 获取微信公众号配置的模板消息
     */
    saveOrUpdate(data) {
        return Request.post('/weixin/template_message/saveOrUpdate', data);
    },

    /**
     * 批量更新微信模板消息Id设置
     */
    batchUpdateWeiXinTemplateMessageId(data) {
        return Request.post('/weixin/template_message/batchUpdateWeiXinTemplateMessageId', data);
    },
    generateWxloginObj() {
        return  Request.get('/weixin/wxapp/fr_LoginWxappSetting');
    },
    /**
     * 生成一个微信登录状态码
     */
    generateWxloginState(redirectUri) {
        let domain = window.location.origin;
        return encodeURI(domain + '|' + redirectUri);
    }
};

export default WeiXinAPI;
